import { useTranslations } from '@/hooks/useTranslations'
import { useMemo } from 'react'

import { StatusBadge, StatusBadgeProps } from '@/components/common/Badge/Status'
import { Skeleton } from '@/components/ui'
import { UserOrganizationStatus, UserStatus } from '@/constants/user'

export const SizeStatusBadge = ({ status }: { status: UserStatus }) => {
  const t = useTranslations('common.badge')

  const statusProps = useMemo((): StatusBadgeProps => {
    switch (status.toLowerCase()) {
      case UserStatus.ACTIVE:
        return {
          variance: 'primary',
          children: t('active'),
        }

      default:
        return {
          variance: 'cancel',
          children: t('inactive'),
        }
    }
  }, [t, status])

  if (!status) return <Skeleton className="w-full md:max-w-72 h-6" />

  return <StatusBadge {...statusProps} />
}
